module.exports = __webpack_public_path__ + "static/media/slide3.5048c561.jpg";